import {History} from 'history';
import fetch from 'node-fetch';
import {NexusTrialCheckerApi, ServicesErrors} from '../../constants';
import {handleResponse, determineErrorLevelForSentry, handleCommonErrorResponse} from '../../utils';
import * as Sentry from '@sentry/browser';

// Determine whether it is possible to assign a trial license to the user.
export async function checkTrial(history: History): Promise<void> {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  };

  // @ts-ignore
  return fetch(NexusTrialCheckerApi, requestOptions)
    .then(handleResponse)
    .catch(error => {
      const errorLevel = determineErrorLevelForSentry(error);

      Sentry.configureScope((scope) => {
        scope.setLevel(errorLevel);
      });

      Sentry.addBreadcrumb({
        category: 'assets',
        message: 'Endpoint ' + NexusTrialCheckerApi,
        data: {
          error: error,
        },
        level: errorLevel,
      });
      Sentry.captureMessage(ServicesErrors.assets.checkTrialFailed, errorLevel);
      return handleCommonErrorResponse(error, history);
    });
}
